// extracted by mini-css-extract-plugin
export default {"unlockUser":"Dk0K8IE5VCOfwgTEIcuI","lockIcon":"_66k0cxxkolGksNtAVqb","unlockButton":"qDTatTSpvAHHk4vZrZan","lockedMessage":"JR80rd9wzA4W9EXgrUdF"};